// extracted by mini-css-extract-plugin
export var filterIncDec = "_du-0";
export var leftBorder = "_du-1";
export var rightBorder = "_du-2";
export var stringInput = "_du-3";